import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormBuilder } from '@angular/forms';
import { Yii } from 'libraries/interfaces/Yii';
import { Subscription } from 'rxjs';
import { EAirSearchFields } from "app_locobook/air-search/e-air-search-fields";

export interface IAirSearchCarrier {
    exclude?: string[];
    include?: string[];
    preferred?: string[];
}

class Wording {
    public readonly preferredCarriers: string = Yii.t('wui-iqba-js', 'Compagnies Préférées');
    public readonly includeExcludeCarriers: string = Yii.t('wui-iqba-js', 'Compagnies Incluses /  Exclues');
    public readonly include: string = Yii.t('wui-iqba-js', 'Inclure');
    public readonly exclude: string = Yii.t('wui-iqba-js', 'Exclure');
}

const maxCarrier: number = 3;

@Component({
    selector: 'air-search-carrier-form',
    templateUrl: './air-search-carrier-form.component.html',
    styleUrls: ['./air-search-carrier-form.component.scss']
})
export class AirSearchCarrierFormComponent implements OnInit, OnDestroy {
    public airSearchCarrierForm: FormGroup;
    public wording: Wording = new Wording();
    public isInclude: boolean;
    public carrierControlName: typeof EAirSearchFields = EAirSearchFields;
    public airSearchCarrierFormChangeSubscription: Subscription;
    private airSearchForm: FormGroup;
    private fields: string[] = [EAirSearchFields.include, EAirSearchFields.exclude, EAirSearchFields.preferred];

    constructor(

      private readonly formGroupDirective: FormGroupDirective,
      private readonly fb: FormBuilder,

    ) {
    }

    public ngOnInit(): void {
        this.initAirSearchCarrierForm();
        this.initIsInclude();
        this.initAirSearchCarrierFormChangeSubscription();
    }

    public ngOnDestroy(): void {
        if (this.airSearchCarrierFormChangeSubscription) {
            this.airSearchCarrierFormChangeSubscription.unsubscribe();
        }
    }

    public toggleIncludeExclude(): void {
        this.isInclude = !this.isInclude;
        this.airSearchCarrierForm.get(this.isInclude ? EAirSearchFields.include : EAirSearchFields.exclude).setValue(this.airSearchCarrierForm.get(this.isInclude ? EAirSearchFields.exclude : EAirSearchFields.include).value);
        this.airSearchCarrierForm.get(this.isInclude ? EAirSearchFields.exclude : EAirSearchFields.include).setValue(null);
    }

    private initAirSearchCarrierForm(): void {
        this.airSearchCarrierForm = this.fb.group({
            exclude: [],
            include: [],
            preferred: []
        });
        this.airSearchForm = this.formGroupDirective.form;
        this.airSearchForm.addControl(EAirSearchFields.carrier, this.airSearchCarrierForm);
    }

    private initIsInclude(): void {
        this.isInclude = this.airSearchCarrierForm.get(EAirSearchFields.exclude).value?.length <= 0;
    }

    private initAirSearchCarrierFormChangeSubscription(): void {
        this.airSearchCarrierFormChangeSubscription = new Subscription();
        this.fields.forEach((field: string): void => {
            this.airSearchCarrierFormChangeSubscription.add(
                this.airSearchCarrierForm.get(field).valueChanges.subscribe((vals: string[]): void => {
                    if (vals?.length > maxCarrier) {
                        this.airSearchCarrierForm.get(field).value.pop();
                    }
                })
            );
        });
    }
}
